import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=47fa89db&scoped=true&lang=html"
import script from "./UserRegistration.vue?vue&type=script&lang=js"
export * from "./UserRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa89db",
  null
  
)

export default component.exports